import { DateTime } from "luxon";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Updater } from "use-immer";

import { IntelligemsAppScopeList } from "@intelligems/ig-types";

import { useHasRequiredShopifyScopes } from "../components/ScopeWrappers/hooks";
import { setDialog } from "../store/slices/global";
import { IAppState } from "../store/types/store";

export function useQueryParams() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), []);
}

export function useQueryParam(param: string): string | null {
  return useMemo(() => {
    const params = new URLSearchParams(document.location.search);
    return params.get(param);
  }, [param]);
}

export const useMaybeShowMissingShopifyScopesDialogAtLogin = () => {
  const snoozeShopifyScopesDialog = useSelector(
    (state: IAppState) => state.appSettings.snoozeShopifyScopesDialog
  );
  const hasRequiredShopifyScopes = useHasRequiredShopifyScopes([
    ...IntelligemsAppScopeList,
  ]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (hasRequiredShopifyScopes !== undefined) {
      if (hasRequiredShopifyScopes) {
        dispatch(setDialog({ dialog: "missingShopifyScope", open: false }));
      } else {
        if (
          !snoozeShopifyScopesDialog ||
          (snoozeShopifyScopesDialog &&
            DateTime.fromSeconds(snoozeShopifyScopesDialog).diffNow("days")
              .days > 2)
        ) {
          dispatch(
            setDialog({
              dialog: "missingShopifyScope",
              open: true,
              props: { initial: true },
            })
          );
        } else {
          dispatch(setDialog({ dialog: "missingShopifyScope", open: false }));
        }
      }
    }
  }, [hasRequiredShopifyScopes]);
};

export const useLazyUpdateValue = (
  value: string,
  onChange: (value: string) => void,
  time = 500
) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, time);

    return () => {
      clearTimeout(timeout);
    };
  }, [value]);
};
